module.exports = __webpack_public_path__ + "static/media/Chunjiman Translated by J_Lee_77777.f0fcdbd6.md";